import axios from "axios";

const EnviarAcumulacionServiClub = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaJson = localStorage.getItem("facturaJson");

  if (!facturaJson) {
    console.error("No se encontró facturaJson en localStorage");
    return;
  }

  const userData = { nic: formattedNic, token: token, venta: JSON.parse(facturaJson), serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover") };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Fidelizacion/EnviarAcumulacionServiClub`, {
      userData,
    });
    console.log(response);
    return response;
  } catch (error) {
    // Manejo del error
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      console.error("Error en la respuesta:", error.response.data);
      return { error: error.response.data.exceptionMessage || "Error desconocido del servidor" };
    } else if (error.request) {
      // La solicitud fue realizada pero no hubo respuesta
      console.error("No hubo respuesta del servidor:", error.request);
      return { error: "No hubo respuesta del servidor, intente de nuevo más tarde." };
    } else {
      // Algo pasó al preparar la solicitud que lanzó un error
      console.error("Error al preparar la solicitud:", error.message);
      return { error: "Error al preparar la solicitud: " + error.message };
    }
  }
};

const puntosServiclub = {
  EnviarAcumulacionServiClub,
};

export default puntosServiclub;
